<template>
	<div style="display:flex" v-if="loading" >
		<div class="body-mid" >

		<div style="background: #FFFFFF;padding-bottom: 20px;padding-top: 20px;">
			<div style="background:#E5EDFB;">
				<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
					font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					解决方案
				</div>
			</div>
				
					
				<div v-if=" tableData2.data.length">
					
						<div style="display: flex;text-align: center;width: 200px;justify-content: space-around;margin-top: 15px;">
								<div @click="orderPaixu(0)" style="display: flex;align-items: center;cursor: pointer;">
									时间<img src="../../assets/images/shaixuan.png" style="width: 15px;height: 15px;" alt="">
								</div>
								<div @click="orderPaixu(1)" style="display: flex;align-items: center;cursor: pointer;">
									关注量<img src="../../assets/images/shaixuan.png" style="width: 15px;height: 15px;" >
								</div>
						</div>
					<div class="body-mid-main" >
						<div class="main-item" v-for="(item, index) in tableData2.data" :key="item.id"
							@click="$router.push(`/solutionDetail/?id=${item.id}`)">
							<div class="main-item-pic">
								<img :src='getImgSrc(item.image)' alt="">
							</div>
							<div class="main-item-title" style=" overflow: hidden;
					                  text-overflow: ellipsis;
					                  max-height: calc(2em + 8px);">
								{{item.title}}
							</div>
						</div>
					</div>
					<div class="body-mid-footer"   @click="getToolsConcernist(1)" v-if='ConcernList.current_page < ConcernList.last_page '>
						加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div>
				</div>
			<el-empty :image-size="200" v-else></el-empty>
		</div>
			<div style="background: #FFFFFF;padding-bottom: 20px;padding-top: 20px;margin-top: 20px;">
				<div style="background:#E5EDFB;">
					<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
						font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
						求助列表
					</div>
				</div>
				<div class="body-mid-top">


					<div class="mid-top-right" style="justify-content: flex-start;padding: 0 15px;">
						<p style="display: flex;align-items: center;cursor: pointer;" @click="sjShaixuan">时间
						<img src='../../assets/images/shaixuan.png'
								style="margin-left: 10px;" alt=""></p>
					</div>
					<el-select v-model="value2" placeholder="请选择" @change="helpsOptionChange">
						<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>

				</div>
				<el-table :data="tableData3.data" stripe style="width: 100%;cursor: pointer;" border=""
					@cell-click='clickItem'>
					<el-table-column prop="subjectcate_name" label="学科" width="133" :resizable="false">
					</el-table-column>

					<el-table-column prop="title" label="名称" width="265" :resizable="false">
					</el-table-column>

					<el-table-column label="求助人" width="130" :resizable="false">
						<template slot-scope="scope">
							<span @click.stop="$router.push(`/geniusClub/geniusInfo?id=${scope.row.user_id}`)">
								{{scope.row.nickname}}</span>
						</template>
					</el-table-column>
					<el-table-column label="当前状态" width="150" :resizable="false">
						<!-- 1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡 -->
						<template slot-scope="scope">
							<span v-if="scope.row.status == 1"> 待审核</span>
							<span v-if="scope.row.status == 2"> 公布中</span>
							<span v-if="scope.row.status == 3"> 已投条</span>
							<span v-if="scope.row.status == 4"> 执行中</span>
							<span v-if="scope.row.status == 5"> 已归档</span>
							<span v-if="scope.row.status == 6"> 已存挡</span>
						</template>
					</el-table-column>

					<el-table-column label="求助时间"  width="220" :resizable="false">
						<template slot-scope="scope">
							<span>{{timeConversion(scope.row.createtime)  }}</span>
						</template>
					</el-table-column>

				</el-table>
				<div style="display: flex;justify-content: center;margin-top: 15px;" @click="getToolsHelpList(1)" v-if='tableData3.current_page < tableData3.last_page '>
					<div class="body-mid-footer">
						加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div>
				</div>
			</div>
			<div style="background: #FFFFFF;padding-bottom: 20px;padding-top: 20px;margin-top: 20px;">
				<div style="background:#E5EDFB;">
					<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
						font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
						我的关注
					</div>
				</div>
				
				<div v-if="ConcernList.total">
					<div class="body-mid-main" >
						<div class="main-item" v-for="(item, index) in ConcernList.data" :key="item.id"
							@click="$router.push(`/geniusClub/geniusInfo?id=${item.id}`)">
							<div class="main-item-pic">
								<img :src='getImgSrc(item.avatar)' alt="">
							</div>
							<div class="main-item-title" style=" overflow: hidden;
					                  text-overflow: ellipsis;
					                  max-height: calc(2em + 8px);">
								{{item.nickname}}
							</div>
						</div>
					</div>
					<div class="body-mid-footer"   @click="getToolsConcernist(1)" v-if='ConcernList.current_page < ConcernList.last_page '>
						加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>
			<div style="background: #FFFFFF;padding-bottom: 20px;padding-top: 20px;margin-top: 20px;">
				<div style="background:#E5EDFB;">
					<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
						font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
						为您推荐
					</div>
				</div>
				<div v-if="RecommendList.total">
					<div class="body-mid-main">
						<div class="main-item" v-for="(item, index) in RecommendList.data" :key="item.id"
							@click="$router.push(`/geniusClub/geniusInfo?id=${item.id}`)">
							<div class="main-item-pic">
								<img :src='getImgSrc(item.avatar)' alt="">
							</div>
							<div class="main-item-title" style=" overflow: hidden;
					                  text-overflow: ellipsis;
					                  max-height: calc(2em + 8px);">
								{{item.nickname}}
							</div>
						</div>
					</div>
					<div class="body-mid-footer" @click="getRecommendList(1)" v-if='RecommendList.current_page < RecommendList.last_page '>
						加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>




		</div>
		<div class="body-right">
			<div @click="$router.push('/solutionDetail/releaseSolution')">
				<img src='../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span>发布</span>
			</div>
			<div style="background: #0297F8;" @click="$router.push('/solutionDetail/createQz')">
				<img src='../../assets/images/dwen.png' alt="" style="width: 19px;height: 19px;"><span>求助</span>
			</div>
			<div style="background:#EEA800;" @click="$router.push('/searchIndex/solutionHelpList')">
				<img src='../../assets/images/ligth.png' alt="" style="width: 14px;height: 18px;"><span>应助</span>
			</div>
			</div>


		</div>

	</div>
</template>
<script>
	export default {
		props:{
			checked:{
				type:Object
			},
			keyWord:{
				type:String
			}
		},
		data() {
			return {
				dialogVisible: false,
				activeTopType: null,

				tableData2: [],
				tableData3: [],
				
				// 1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡

				options2: [ {
					value: 2,
					label: '公布中'
				}, {
					value: 3,
					label: '已投条'
				}, {
					value: 4,
					label: '执行中'
				}, {
					value: 5,
					label: '已归档'
				}, {
					value: 6,
					label: '已存挡'
				}],
				value2: '',
				shaiXuan:{
					tags:[],
					subjectcate_ids:[],
					industry_ids:[],
					stage_ids:[],
					status:'',
					keywords:'',
					page:1,
					order_type:0
				},
				HelpshaiXuan:{
					tags:[],
					subjectcate_ids:[],
					industry_ids:[],
					stage_ids:[],
					status:'',
					keywords:'',
					page:1,
					order:''
				},
				toolsPage:{},
				ConcernList:[],
				ConcernPage:1,
				RecommendList:[],
				RecommendPage:1,
				loading:false,
				RankGuys:[]
			}
		},
		watch:{
			checked:{
				handler(newValue,oldValue){
					this.shaiXuan.subjectcate_ids = newValue.checkedXK
					this.shaiXuan.tags = newValue.checkedJL
					this.shaiXuan.industry_ids = newValue.checkedHY
					this.shaiXuan.stage_ids = newValue.checkedJD
					this.chooseTags()
				},
				deep: true,
			},
			keyWord:{
				handler(newValue,oldValue){    
					this.shaiXuan.keywords = newValue
					this.HelpshaiXuan.keywords = newValue
					this.chooseTags()
				},
			},
		},
		created() {
			this.shaiXuan.keywords = this.$route.query.search
			this.getToolsConcernist()
			this.getRecommendList()
			this.getToolsHelpList()
			this.chooseTags()
			this.getToolsList()
		},
		methods: {
			orderPaixu(e){
				this.shaiXuan.order_type = e
				this.getToolsList()
			},
			toolsOptionChange(e){
				this.shaiXuan.status = e
				this.getToolsList()
			},
			helpsOptionChange(e){
				this.HelpshaiXuan.status = e
				this.getToolsHelpList()
			},
			chooseTags(){
				// this.showLoading();
				
				this.getToolsList()
				this.loading = true
				// this.hideLoading();
			}, 
			sjShaixuan(){
				this.HelpshaiXuan.order == 'id desc' ? this.HelpshaiXuan.order = 'id asc' : this.HelpshaiXuan.order = 'id desc'
				this.getToolsHelpList()
			},
			async getRank(){ 
				const rank = await this.$api.getGeniusContributeTop()
				this.RankGuys = rank.data.data
				console.log(rank);
			},
			async getRecommendList(type){
				if(this.$store.state.userInfo  == 0) return
				let list
				if(type == 1){
					this.RecommendPage++
					list =await this.$api.recommendGeniusList({page:this.RecommendPage})
					this.RecommendList.data = this.RecommendList.data.concat(list.data.data)
					this.RecommendList.current_page = list.data.current_page
					this.RecommendList.last_page = list.data.last_page
				}else{
					list =await this.$api.recommendGeniusList({page:this.RecommendPage})
					this.RecommendList = list.data
				}
			},
			async getToolsConcernist(type){
				if(this.$store.state.userInfo  == 0) return
				let list
				if(type == 1){
					this.ConcernPage++  
					list =await this.$api.careGeniusList({page:this.ConcernPage})
					this.ConcernList.data = this.ConcernList.data.concat(list.data.data)
					this.ConcernList.current_page = list.data.current_page
					this.ConcernList.last_page = list.data.last_page
				}else{
					list =await this.$api.careGeniusList({page:this.ConcernPage})
					this.ConcernList = list.data
				}
			},
			async getToolsHelpList(type){
				let list
				if(type == 1){
					this.HelpshaiXuan.page++
					list =await this.$api.schemeHelphelpList({...this.HelpshaiXuan})
					this.tableData3.data = this.tableData3.data.concat(list.data.data)
					this.tableData3.current_page = list.data.current_page
					this.tableData3.last_page = list.data.last_page
				}else{
					list =await this.$api.schemeHelphelpList({...this.HelpshaiXuan})
					this.tableData3 = list.data
				}
			},
			async getToolsList(type){
				let list
				if(type == 1){
					this.shaiXuan.page++
					list =await this.$api.schemehelpList({...this.shaiXuan})
					this.tableData2.data = this.tableData2.data.concat(list.data.data)
					this.tableData2.current_page = list.data.current_page
					this.tableData2.last_page = list.data.last_page
				}else{
					list =await this.$api.schemehelpList({...this.shaiXuan})
					this.tableData2 = list.data
				}
			},

			clicktools(column) {
				this.$router.push(`/zyTools?id=${column.id}`)
			},
			clickItem(column) {
				console.log(column)
				this.$router.push(`/solutionDetail/QZdetail?id=${column.id}`)
			},
			handleChange(val) {
				console.log(val);
			}
		}
	}
</script>
<style scoped lang="less">
	/deep/.el-table__cell {
		color: #222222;
		text-align: center;
	}

	/deep/.el-input__inner {
		color: #222222;
	}

	/deep/.el-input__inner::placeholder {
		color: black !important;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}

	.table {
		.table-item {
			align-items: center;
			display: flex;
			padding: 0 20px;
			justify-content: space-between;
			height: 55px;

		}

	}

	.pointer {
		p {
			cursor: pointer;
			margin-bottom: 3px;
		}

		p:hover {
			color: #0052D9;
		}
	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}

	/deep/.el-dialog__title {
		font-size: 20px;
		text-align: center;
		font-weight: bold;
	}

	.body-person-item {
		width: 151px;
		height: 270px;
		background: url('../../assets/images/personBg.png') no-repeat;
		background-position: center bottom;
		background-size: contain;

		& p {
			margin-top: 6px;
			font-size: 18px;
		}
	}

	.body-person {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
	}

	.page-last-body {
		padding: 40px 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.page-last-top {
		display: flex;
		justify-content: space-between;
	}

	.huanyih {
		font-size: 18px;
		width: 110px;
		height: 40px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
		line-height: 40px;
		margin-right: 20px;
	}

	.page-last-title {

		width: 120px;
		height: 40px;
		background: #0052D9;
		border-radius: 0px 20px 20px 0px;
		color: white;
		font-size: 22px;
		font-family: PingFang;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.page-last {
		padding-top: 30px;
		margin-top: 20px;
		width: 100%;
		height: 515px;
		background: #FFFFFF;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	.body-mid-footer {
		width: 95%;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;

		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}

	.main-item {
		cursor: pointer;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
		transition: all .5s;
	}

	.main-item:hover {
		transform: scale(1.02);
		box-shadow: 0 0 10px #bababa;
	}

	.main-item-pic {
		width: 100%;
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;
		

	}
	.main-item-title{
		width: 100%;
		text-align: center;
	}
	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}

	.body-mid-main {
		display: flex;
		flex-wrap: wrap;
		padding-left:20px;
		justify-content: flex-start;
	}

	.main-item {
		margin: 13px;
		margin-left: 18px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
	}

	.activeTop {
		color: white;
		background: #0052D9;
	}

	.mid-top-right {
		justify-content: space-around;
		display: flex;
		width: 430px;

		&>div {
			cursor: pointer;
			width: 100px;
			height: 38px;
			line-height: 38px;
			text-align: center;
			border: 1px solid #D2D2D2;
		}

		&>div:hover {
			background: #0052D9;
			color: white;
		}
	}

	.body-mid-top {
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 20px;
		padding-right: 20px;
	}

	.body-mid {
		margin: 0 20px;
		width: 900px;
		box-sizing: border-box;
	}
</style>